<template>
  <div>
    <SmallTitle class="py-2" text="Sample transactions" />

    <p v-if="!accountsExtended">Transactions loading...</p>
    <p v-if="!accountsExtended"><b>Info: </b>{{ $t('longLoadingText') }}</p>

    <ShowMore :defaultHeight="120" :hide-link="!sortedTransactions.length">
      <transition-group name="transaction" v-if="sortedTransactions.length">
        <AccountsTransactionsItem
          v-for="transaction in sortedTransactions"
          :key="`transaction-${transaction.resourceId}`"
          :transaction="transaction"
        />
      </transition-group>
      <span v-else-if="accountsExtended">No transactions for the default period</span>
    </ShowMore>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SmallTitle from '../../elements/SmallTitle'
import ShowMore from '../../elements/ShowMore'
import AccountsTransactionsItem from './AccountsTransactionsItem'

export default {
  data() {
    return {
      countOfTransactions: 30
    }
  },
  computed: {
    filteredTransactions() {
      if (!this.accountsExtended) {
        return []
      }
      return Object.values(this.accountsExtended).map(account => {
        if (this.selectedAccounts.includes(account.resourceId)) {
          return this.extendTransactionData(account.transactions, account.resourceId)
        }
        return []
      })
    },
    sortedTransactions() {
      return this.sortTransactions(this.flatSingle(this.filteredTransactions)).splice(0, this.countOfTransactions)
    },
    ...mapGetters('personal', ['selectedAccounts', 'accountsExtended', 'accountNameByResourceId'])
  },
  components: {
    SmallTitle,
    ShowMore,
    AccountsTransactionsItem
  },
  methods: {
    sortTransactions(transactions) {
      return transactions.sort((a, b) => {
        const aDate = new Date(a.transactionDate || a.bookingDate || '').getTime()
        const bDate = new Date(b.transactionDate || b.bookingDate || '').getTime()
        return bDate - aDate
      })
    },
    extendTransactionData(transactions, resourceId) {
      const accountName = this.accountNameByResourceId(resourceId)
      return transactions.map(transaction => ({ ...transaction, ...{ accountName } }))
    },
    flatSingle(arr) {
      return [].concat(...arr)
    }
  }
}
</script>

<style lang="scss" scoped>
.transaction-enter-active, .transaction-leave-active {
  transform: translateY(0);
  transition: all 0.2s;
}
.transaction-enter, .transaction-leave-to {
  opacity: 0;
}
.transaction-enter {
  transform: translateY(-40px);
}
.transaction-leave-to {
  transform: translateY(40px);
}
</style>
